import PriceEditingContent from './PriceEditingContent';

export default PriceEditingContent;
